<template>
  <a-layout>
    <Breadcrumb />
    <div class="page-title-container">
      <span class="page-title">进度管理</span>
    </div>
    <div class="content-container">
      <div class="list-container" style="margin-top: 20px;">
        <div class="table-btn-container">
          <span class="total-capacity-text">总装机容量：{{ totalCapacity }} MW</span>
        </div>
        <div class="search-container" style="margin: 0 0 10px 0;">
          <a-input size="small" placeholder="项目名称" v-model="searchParams.projectName" class="medium-search-input" />
          <a-input size="small" placeholder="所属公司" v-model="searchParams.companyName" class="medium-search-input" />
          <a-cascader size="small" placeholder="所在区域" :options="regionOptions" v-model="searchParams.regionIds" change-on-select style="width:240px;margin-right: 20px"  />
          <a-select
              size="small"
              v-model="searchParams.engineeringNode"
              class="search-select" style="margin-right: 20px">
            <a-select-option value="">所有工程进度</a-select-option>
            <a-select-option value="INFO_COLLECTION">资料收集</a-select-option>
            <a-select-option value="INFO_REVIEW">资料审核</a-select-option>
            <a-select-option value="POWER_STATION_DESIGN">电站设计</a-select-option>
            <a-select-option value="POWER_STATION_CONSTRUCTION">电站施工</a-select-option>
            <a-select-option value="REQUEST_GRID_CONNECTION">并网申请</a-select-option>
            <a-select-option value="GRID_CONNECTION_ACCEPTANCE">并网验收</a-select-option>
            <a-select-option value="COMPLETION_ACCEPTANCE">竣工验收</a-select-option>
          </a-select>
          <a-select
              size="small"
              v-model="searchParams.paymentNode"
              class="search-select" style="margin-right: 20px">
            <a-select-option value="">所有付款进度</a-select-option>
            <a-select-option value="PREPAYING">申请预付款</a-select-option>
            <a-select-option value="PREPAID">预付款完成</a-select-option>
            <a-select-option value="GRID_CONNECTION_PAYMENT">并网请款</a-select-option>
            <a-select-option value="GRID_CONNECTION_PAID">并网款完成</a-select-option>
            <a-select-option value="REQUEST_COMPLETION_PAYMENT">竣工请款</a-select-option>
            <a-select-option value="COMPLETION_PAID">竣工款完成</a-select-option>
            <a-select-option value="ACCEPTANCE_TRANSFER">验收移交</a-select-option>
            <a-select-option value="REQUEST_WARRANTY_PAYMENT">质保金请款</a-select-option>
            <a-select-option value="WARRANTY_PAID">质保金付款完成</a-select-option>
          </a-select>
          <a-button
              size="small"
              @click="onSearch"
              class="search-btn"
          >搜索</a-button
          >
        </div>
        <a-table
            :columns="tblColumns"
            :data-source="tblData"
            :pagination="pagination"
            :loading="loading"
            size="small"
            rowKey="projectId"
            @change="onTableChange"
        >
          <a-space slot="action" slot-scope="record">
            <a @click="manageProgress(record)">进度管理</a>
          </a-space>
          <div slot="coloredProjectName" slot-scope="record">
            <div v-if="record.overallStatus === '复核驳回' || record.overallStatus === '风险评估驳回'"  class="warning-text">
              {{ record.projectName }}
            </div>
            <div v-else>
              {{ record.projectName }}
            </div>
            <div v-if="record.companyName!==null && record.companyName!==''" class="desc-text">{{ record.companyName }}</div>
          </div>
          <div slot="coloredProjectState" slot-scope="record">
            <span v-if="record.overallStatus === '复核驳回' || record.overallStatus === '风险评估驳回'"  class="warning-text">
              {{ record.overallStatus }}
            </span>
            <span v-else>
              {{ record.overallStatus }}
            </span>
          </div>
        </a-table>
      </div>
    </div>

  </a-layout>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { tsFormat } from "@/components/DateUtils";
import {
  listProjects,
  receiveDoc,
  setBatchNumber,
  batchDelete,
  listUnderConstructionProjects
} from "@/services/DocService";
import {baseURL} from "@/services/HttpService";
import { regionOptions } from "@/geo/region";
import { isUserAdmin} from "@/services/UserService";
import {fetchDocListPermission} from "@/services/PermissionApi";
import {loadTaskCounts, refreshTaskCounts} from "@/services/DashboardService";

const tblColumns = [
  {
    title: "项目名称",
    scopedSlots: {customRender: "coloredProjectName"}
  },
  {
    title: "装机容量(MW)",
    dataIndex: "projectRecord",
    width: "8%"
  },
  {
    title: "所在区域",
    dataIndex: "regionFullName",
    width: "18%"
  },
  {
    title: "项目进度",
    dataIndex: "engineeringNodeName",
    width: "8%"
  },
  {
    title: "付款进度",
    dataIndex: "paymentNodeName",
    width: "8%"
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    width: "12%"
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: {customRender: "action"},
    width: "20%"
  }
];
export default {
  components: { Breadcrumb },
  data() {
    return {
      tblColumns,
      tblData: [],
      regionOptions,
      searchParams: {
        projectName: "",
        companyName: "",
        batchNumber: "",
        state: "",
        engineeringNode:"",
        paymentNode:"",
        regionIds:[]
      },
      pagination: {
        size: "small",
        showQuickJumper: true
      },
      loading: false,
      viewUrl: baseURL + "/attachment?fileName=",
      selectedRowKeys: [],
      batchNumber: "",
      modalVisible: false,
      isAdmin: false,
      canSetBatchNumber: false,
      canAddProject: false,
      totalCapacity: 0
    };
  },
  computed: {
  },
  created() {
    isUserAdmin().then(resp => {
      if(resp.data.code === "SUCCESS") {
        this.isAdmin = resp.data.data;
      }
    });
    fetchDocListPermission().then(resp => {
      if(resp.data.code === "SUCCESS") {
        let permissions = resp.data.data;
        this.canSetBatchNumber = permissions.canSetBatchNumber;
        this.canAddProject = permissions.canAddProject;
        if(this.canSetBatchNumber===true) {
          this.addBatchNumberColumn();
        }
      }
    });
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    manageProgress(record){
      this.$router.push({path: `/adm/manage-progress/${record.projectId}`});
    },
    onTableChange(p) {
      this.fetchList(p.current, p.pageSize);
    },
    onSearch() {
      this.fetchList();
    },
    onReset() {
      this.searchParams.projectName = "";
      this.searchParams.companyName = "";
      this.searchParams.state = "";
      this.searchParams.batchNumber = "";
      this.searchParams.engineeringNode = "";
      this.searchParams.paymentNode = "";
      this.searchParams.regionIds = [];
      this.fetchList();
    },
    fetchList(pageNum = 1, pageSize = 10) {
      let params = {
        ...this.searchParams,
        pageNum,
        pageSize
      };

      listUnderConstructionProjects(params)
          .then(response => {
            this.loading = false;
            if (response.data.code === "FAILED") {
              console.log("服务端错误", response.data.errorMsg);
              this.$message.error("读取数据失败");
            } else {
              this.setTblData(response);
            }
          });
    },
    setTblData(response) {
      let buzData = response.data.data;
      let rltList = buzData.records;
      if (rltList) {
        let totalCapacity = 0;
        rltList.forEach(item => {
          if (item.createTime) {
            item.createTime = tsFormat(item.createTime);
          }
          if(item.submitTime) {
            item.submitTime = tsFormat(item.submitTime);
          }
          if(item.assessTime) {
            item.assessTime = tsFormat(item.assessTime);
          }
          if(item.metricZip) {
            item.metricZip = this.viewUrl + item.metricZip;
          }
          if(item.engineeringNodeName===undefined || item.engineeringNodeName===null) {
            item.engineeringNodeName = '--';
          }
          if(item.paymentNodeName===undefined || item.paymentNodeName===null) {
            item.paymentNodeName = '--';
          }
          if(item.projectRecord && !isNaN(item.projectRecord)) {
            totalCapacity += parseFloat(item.projectRecord);
          }
        });
        let factor = Math.pow(10, 5); // 保留两位小数
        let capacity = Math.round(totalCapacity * factor) / factor;
        this.totalCapacity = capacity;
      }
      this.tblData = rltList;
      const pagination = { ...this.pagination };
      pagination.current = buzData.pageNum;
      pagination.total = buzData.total;
      pagination.pageSize = buzData.pageSize;
      pagination.showTotal = function (total, range) {
        return `当前显示 ${range[0]} - ${range[1]} 条, 共 ${total} 条`;
      };
      this.pagination = pagination;
    },


  }
};
</script>

<style scoped>
.table-btn-container {
  padding: 10px 0;
}
.input-container{
  padding-top: 4px;
  padding-bottom: 4px;
}
.input-label {
  display: inline-block;
  width: 100px;
  margin-right: 10px;
}
.val-input {
  width: 200px;
}
.desc-text {
  font-size: 12px;
  color: #999;
}
.total-capacity-text {
  font-size: 12px;
  color: #999;
  margin-left: 50px;
}
</style>
